import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PicGenerator from '../html2img/PicGenerator.vue';
import imgLoad from '../v-img-load';
import mixin from '../mixin';
import ReviewItem from './ReviewItem.vue';
import util from '../../../util';
import { getCardData as _getCardData, getCardImg as _getCardImg } from '../../../util/service';
import Report from '../../../util/report';
var VERSION = '1.0.26';
var MAX_TRY_COUNT = 3;
var DEFAULT_SRC = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQYV2N48+bNfwAJUAPE01IbLQAAAABJRU5ErkJggg==';
var reportInstance = null;
export default {
  name: 'CloudSealCard',
  mixins: [mixin],
  directives: {
    imgLoad: imgLoad
  },
  props: {
    // 服务端渲染缩放比例
    ssrScale: {
      type: Number,
      default: 1
    },
    // 是否是服务端渲染
    isSSR: {
      type: Boolean,
      default: false
    },
    // html2canvas 参数
    options: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    // 变量
    params: {
      type: [Object],
      default: function _default() {
        return {};
      }
    },
    mode: {
      type: [String],
      default: 'pic'
    },
    backData: {
      type: [Object]
    },
    id: {
      type: [String, Number]
    },
    env: {
      type: [String]
    },
    url: {
      type: [String],
      default: 'https://film.qq.com/x/cloud_seal'
    }
  },
  data: function data() {
    return {
      clientRect: {},
      isLoading: false,
      picLoading: false,
      cardData: null,
      startTime: Date.now(),
      img: null,
      scale: this.ssrScale || 1,
      innerMode: this.mode,
      DEFAULT_SRC: DEFAULT_SRC
    };
  },
  methods: {
    imgLoadReport: function imgLoadReport(res) {
      var error = res.error;

      if (error) {
        this.reportLog('imgLoadError', util.getVal(error, 'message'));
        console.error('img load error', error);
      }

      reportInstance.reportImgLoad(res);
    },
    emitError: function emitError(type) {
      // 1 请求数据失败 2 生成图片失败
      this.$emit('error', type);
    },
    printCost: function printCost(costName) {
      var cost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      reportInstance.setReportData(costName, cost);
      console.log("".concat(costName, " cost:").concat(cost));
    },
    reportLog: function reportLog(type, message) {
      reportInstance.reportLog(type, message);
    },

    /**
       * 设置card 样式
       * * */
    setCardStyleText: function setCardStyleText() {
      var _this = this;

      if (!this.cardData) {
        return;
      }

      this.$nextTick(function () {
        util.createCardStyleTag("".concat(util.CARD_CLASS_PREFIX).concat(util.getVal(_this.cardData, 'id')), util.getVal(_this.cardData, 'style'));
      });
    },

    /**
    * 设置缩放比
    */
    setScale: function setScale() {
      var _this2 = this;

      if (!this.cardData) return;
      this.$nextTick(function () {
        var $wrap = _this2.$el;
        var baseWidth = $wrap && $wrap.getBoundingClientRect().width;
        _this2.scale = baseWidth ? baseWidth / _this2.cardData.width : 1;
      });
    },
    getCardImg: function getCardImg() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, key, img;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.isLoading = true;
                params = JSON.stringify(_this3.params);
                key = util.getToken("".concat(_this3.query.id, "-").concat(_this3.query._ || '', "-").concat(params));
                _context.next = 5;
                return _getCardImg({
                  url: "".concat(_this3.url, "/cgi/card/getCardImgById?key=").concat(key),
                  query: _objectSpread(_objectSpread({}, _this3.query), {}, {
                    params: params
                  })
                }).catch(function () {
                  _this3.isLoading = false; // 兜底

                  _this3.innerMode = 'pic';

                  _this3.reportLog('serverRenderError', _this3.id);

                  _this3.getCardData();
                });

              case 5:
                img = _context.sent;

                if (img) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _this3.isLoading = false;
                _this3.img = img;

                if (_this3.img) {
                  _this3.$emit('success', _this3.img);

                  _this3.printCost('totalCost', Date.now() - _this3.startTime);
                }

                reportInstance.reportPerformance();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
       * 加载卡片模板
       * @returns {Promise<void>}
       */
    getCardData: function getCardData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var vm, cardData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vm = _this4;

                if (vm.id) {
                  _context2.next = 4;
                  break;
                }

                // 没有id的话，使用backData 里面的值
                vm.cardData = vm.backData;
                return _context2.abrupt("return");

              case 4:
                vm.isLoading = true;
                _context2.next = 7;
                return _getCardData({
                  url: "".concat(vm.url, "/cgi/card/getCardById"),
                  query: _this4.query,
                  reportInstance: reportInstance
                }).catch(function () {
                  vm.isLoading = false;

                  if (vm.backData) {
                    // 使用兜底数据
                    console.warn('【cloud-seal-card】使用兜底数据..', vm.backData);
                    reportInstance.reportLog('backData', vm.id);
                    return vm.backData;
                  }

                  reportInstance.reportLog('fetchDataError', vm.id);
                  reportInstance.reportPerformance();
                  vm.emitError(1);
                });

              case 7:
                cardData = _context2.sent;
                vm.isLoading = false;
                vm.cardData = cardData;

                if (vm.cardData) {
                  vm.$emit('ready', vm.cardData);
                }

                vm.setScale();
                vm.setCardStyleText();

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    imgLoadError: function imgLoadError(e, cost) {
      // 图片加载失败了，还掉showImg兜底，比没有图生成好
      this.showImage(cost);
    },
    imgLoad: function imgLoad(cost) {
      this.showImage(cost);
    },
    picGeneratorFailHandler: function picGeneratorFailHandler(e) {
      this.reportLog('picGeneratorFailHandler', e && e.message);
      console.error(e);
      this.emitError(2);
    },

    /** *
       *  生产图片
       * @param replaceCost
       * @returns {Promise<void>}
       */
    showImage: function showImage(replaceCost) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var startTime, imgs, timeOut, timer, tryCount, run;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.printCost('replaceCost', replaceCost);

                _this5.picLoading = true;
                startTime = Date.now();
                imgs = _this5.$el.querySelectorAll('img') || [];
                timeOut = Math.max(imgs.length * 600, 5000);
                timer = null;
                tryCount = 0;

                run = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
                    var isError, img;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            isError = false; // 这里做超时处理

                            timer = setTimeout(function () {
                              isError = true;

                              if (tryCount < MAX_TRY_COUNT) {
                                tryCount += 1;
                                return run(resolve, reject);
                              }

                              reject(new Error("show image timeout:".concat(timeOut, ", retry count: ").concat(tryCount)));
                            }, timeOut); // 5s 没有生成完，认为失败(html2canvans 里面有些时候不会返回状态)

                            _context3.next = 4;
                            return _this5.$refs.generator.generate(_objectSpread({
                              maskColor: 'rgba(0,0,0,.08)',
                              autoReplace: true,
                              logging: false,
                              allowTaint: false,
                              useCORS: true,
                              x: '',
                              // fix ios ui webkit 内核生成图片透明问题
                              y: '',
                              scale: window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio
                            }, _this5.options));

                          case 4:
                            img = _context3.sent;

                            if (!isError) {
                              // 生成图片了。终止定时器
                              clearTimeout(timer);
                              resolve(img);

                              _this5.printCost('showImgCost', Date.now() - startTime);
                            }

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function run(_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }(); // 生成图片


                _context4.next = 10;
                return new Promise(run).catch(function (e) {
                  console.error(e);

                  _this5.emitError(2);

                  _this5.reportLog('showImgError', util.getVal(e, 'message'));

                  _this5.picLoading = false;
                });

              case 10:
                _this5.img = _context4.sent;
                _this5.picLoading = false;

                if (_this5.img) {
                  _this5.$emit('success', _this5.img);

                  _this5.printCost('totalCost', Date.now() - _this5.startTime);
                } // 上报


                reportInstance.setReportData('showImgReTryCount', tryCount);
                reportInstance.reportPerformance();

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(_this6.innerMode !== 'local')) {
                _context5.next = 10;
                break;
              }

              if (!(_this6.innerMode === 'server')) {
                _context5.next = 6;
                break;
              }

              _context5.next = 4;
              return _this6.getCardImg();

            case 4:
              _context5.next = 8;
              break;

            case 6:
              _context5.next = 8;
              return _this6.getCardData();

            case 8:
              _context5.next = 11;
              break;

            case 10:
              _this6.$emit('ready');

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  mounted: function mounted() {
    var _this7 = this;

    reportInstance = new Report({
      mode: this.mode,
      id: this.id,
      version: VERSION
    });
    this.$nextTick(function () {
      _this7.clientRect = _this7.$el.getBoundingClientRect();
    });
  },
  computed: {
    query: function query() {
      var _ref2 = util.getUrlParamObj() || {},
          version = _ref2._cloud_seal_version,
          _ref2$_cloud_seal_env = _ref2._cloud_seal_env,
          env = _ref2$_cloud_seal_env === void 0 ? this.env : _ref2$_cloud_seal_env;

      var query = {
        id: this.id,
        c_version: VERSION
      }; // 预览的不走缓存

      var isPreview = version || env;

      if (isPreview) {
        version && (query.version = version);
        env && (query.env = env);
        query._ = Date.now();
      }

      return query;
    },
    loadingStyle: function loadingStyle() {
      var _this$clientRect = this.clientRect,
          width = _this$clientRect.width,
          height = _this$clientRect.height;

      if (height) {
        var realHeight = this.cardRealHeight || height;
        return {
          width: "".concat(width, "px"),
          height: "".concat(realHeight, "px"),
          display: 'block'
        };
      }

      return {
        display: 'none'
      };
    },
    paramsObj: function paramsObj() {
      return util.getParamsObj(this.paramsList, this.params);
    },
    cardRealHeight: function cardRealHeight() {
      return Math.floor(this.scale * util.getVal(this.cardData, 'height'));
    },
    cardRealWidth: function cardRealWidth() {
      return Math.floor(this.scale * util.getVal(this.cardData, 'width'));
    },
    cardBgImg: function cardBgImg() {
      return util.replaceParams(util.getVal(this.cardData, 'bgImg'), this.paramsObj);
    },
    // 背景图只要宽高就行了
    bgStyle: function bgStyle() {
      return this.cardData ? {
        width: "".concat(this.cardData.width, "px"),
        height: "".concat(this.cardData.height, "px")
      } : {};
    },
    cardStyle: function cardStyle() {
      var scale = this.scale;
      return this.cardData ? {
        width: "".concat(this.cardData.width, "px"),
        height: "".concat(this.cardData.height, "px"),
        transformOrigin: 'top left',
        '-webkit-transform-origin': 'top left',
        transform: "scale(".concat(scale, ")"),
        '-webkit-transform': "scale(".concat(scale, ")"),
        backgroundColor: this.cardData.bgColor
      } : {};
    },
    paramsList: function paramsList() {
      return util.parseJson(util.getVal(this.cardData, 'params')) || [];
    },
    attachmentList: function attachmentList() {
      return util.parseJson(util.getVal(this.cardData, 'attachment')) || [];
    },
    dataIsReady: function dataIsReady() {
      return this.innerMode === 'local' || this.innerMode === 'pic' && this.cardData;
    }
  },
  components: {
    ReviewItem: ReviewItem,
    PicGenerator: PicGenerator
  }
};